import React, { PureComponent } from 'react';

class RatingField extends PureComponent {
    handleChange() {
        const value = this.input.value;
        this.props.setJobRating(value);
    }

    render() {
        const { jobRating, setJobRating } = this.props;

        return (
            <div className="fieldwrap">
                <label htmlFor="jobRating">How good or bad is your job and why?</label>
                <input
                    onChange={e => this.handleChange()}
                    ref={(input) => {
                        this.input = input;
                    }}
                    type="text"
                    value={jobRating}
                    name="jobRating"
                />
            </div>
        );
    }
}

export default RatingField;



// WEBPACK FOOTER //
// ./src/Form/RatingField.js